import React, { useState } from 'react'
import classNames from "classnames/bind";

import styles from "./DeficitItem.module.css";
import { DeficitModal } from 'components/DeficitModal';
import { Modal } from 'components/Modal';
import { DietanamnezChartItem } from 'types/DietanamnezItem';

const cx = classNames.bind(styles);

// Серый +-33%, оранжевый +-34-66%, красный +-67% и более
const getConfig = (percent?: number | null) => {
	if (percent && percent < -66) {
		return {
			text: "Высокий риск",
			color: "var(--maroon)",
		};
	}

	if (percent && percent < -33) {
		return {
			text: "Требует внимания",
			color: "var(--orange)",
		};
	}

	return {
		text: "Легкое отклонение",
		color: "var(--achromatic)",
	};
};


type Props = {
	item: DietanamnezChartItem,
	percent: number | null;
};

export const DeficitItem: React.FC<Props> = ({ item, percent }) => {
	const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

	const showModal = () => {
		setIsOpenModal(true);
		document.body.style.overflow = "hidden";
	}

	const closeModal = () => {
		setIsOpenModal(false);
		document.body.style.overflow = "auto";
	}

	const config = getConfig(percent);

	return (
		<>
			{percent && percent < 0 &&
				<>
					<div
						className={cx("item")}
						style={{ backgroundColor: config.color }}
						onClick={showModal}
					>
						<div className={cx("item_content")}>
							<div className={cx("item_product")}>
								{item.label.length <= 14 ? item.label : `${item.label.slice(0, 14)}...`}
							</div>
							<div className={cx("item_risk")}>
								<div className={cx("risk_percent")}>{`${percent}%`}</div>
								<div className={cx("risk_conclusion")}>{config.text}</div>
							</div>
						</div>
						<div className={cx("item_details")}>
							<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
								<path fill="none" d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
							</svg>
						</div>
					</div>
					<Modal isOpen={isOpenModal} handleClose={closeModal}>
						<DeficitModal item={item} percent={percent} config={config} handleClose={closeModal} />
					</Modal>
				</>
			}
		</>
	)
}
